export const metaObject: any = {};
